'use client';

import type { NextPage } from 'next';
import styles from './input-field.module.scss';
import { InputFieldType } from '@/types/getNotified.types';

const InputField: NextPage<InputFieldType> = ({
  className = '',
  label,
  value,
  onChange,
  error,
}) => {
  return (
    <div className={[styles.inputField, className].join(' ')}>
      <div className={styles.label}>{label}</div>
      <div
        className={[styles.row, error ? styles.error : '']
          .filter(Boolean)
          .join(' ')}
      >
        <input
          className={styles.enterYourEmail}
          placeholder={`Enter your ${label?.toLowerCase()}`}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default InputField;
